module.exports = __webpack_public_path__ + "img/14.382fe6ab.svg";